import { Component, OnDestroy, OnInit } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { CityDto, ContractDto, InsurerDto, ProvinceDto, SiteDto } from "src/app/api/models";
import { AppState, getState } from "src/app/state/app.state";
import { setTitle } from "../../title/state/title.actions";
import { resetQuestionnaire, setQuestionConfirmed } from "../../transaction-info/state/transaction-info.actions";
import { getSelectedInsurer, getAdmissionDate, getSelectedProvince, getSelectedSite, getSelectedCity, getAnswersSummary } from "../../transaction-info/state/transaction-info.selectors";
import { AnswersSummary } from "../model/AnswersSummary";

@Component({
    selector: "app-confirm-question",
    templateUrl: "./confirm-question.component.html",
    styleUrls: ["./confirm-question.component.scss"],
    standalone: false
})
export class ConfirmQuestionComponent implements OnInit,OnDestroy {
	public insurer$: Observable<InsurerDto> = this.store.pipe(select(getSelectedInsurer));
	public admissionDate$: Observable<Date> = this.store.pipe(select(getAdmissionDate));
	public province$: Observable<ProvinceDto> = this.store.pipe(select(getSelectedProvince));
	public hospital$: Observable<SiteDto> = this.store.pipe(select(getSelectedSite));
	public city$: Observable<CityDto> = this.store.pipe(select(getSelectedCity));
	public answersSummary$: Observable<AnswersSummary[]> = this.store.pipe(select(getAnswersSummary));
	public insurerName: string;
	public provinceName: string;
	public contract: ContractDto;
	public cityName: string;
	public hospitalName: string;
	public hospitalAddress: string;
	private subs: Subscription[] = [];

	constructor(private store: Store<AppState>) {
		this.subs.push(
			getState(this.store).subscribe(state=>{
				this.provinceName = "provinceName" + state.transactionInfo.selectedLanguage.languageCode;
				this.cityName = "text" + state.transactionInfo.selectedLanguage.languageCode;
				this.insurerName = "insurerName" + state.transactionInfo.selectedLanguage.languageCode;
				this.hospitalName = "hospitalName" + state.transactionInfo.selectedLanguage.languageCode;
				this.hospitalAddress = "addressText" + state.transactionInfo.selectedLanguage.languageCode;

				this.contract = state.transactionInfo.selectedContract;
			})
		);
	}

	ngOnInit(): void {
		this.store.dispatch(
			setTitle({
				data: "TITLE_QUESTION_ANSWER_SUMMARY",
				data2: "TITLE_QUESTION_ANSWER_SUMMARY_INFO",
			})
		);
	}

	ngOnDestroy(): void {
		this.subs.forEach((_) => _.unsubscribe());
	}

	onClickRetour(): void {
		this.store.dispatch(resetQuestionnaire());
	}
	onClickOk(): void {
		this.store.dispatch(setQuestionConfirmed({ data: true }));
	}
}
